import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://crypto-expense-management-backend.onrender.com';

export interface WalletBalance {
  success: boolean;
  wallet_address: string;
  sol_balance: number;
  pyusd_balance: number;
  sol_balance_formatted: string;
  pyusd_balance_formatted: string;
}

export interface OrganizationBalance {
  success: boolean;
  wallet_address: string;
  sol_balance: number;
  pyusd_balance: number;
  sol_balance_formatted: string;
  pyusd_balance_formatted: string;
}

class WalletService {
  async getWalletBalance(walletAddress: string): Promise<WalletBalance> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/wallet/balance/${walletAddress}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      throw error;
    }
  }

  async getOrganizationBalance(): Promise<OrganizationBalance> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/v1/wallet/organization/balance`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching organization balance:', error);
      throw error;
    }
  }
}

export default new WalletService();
